import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setCredentials } from "../redux/slices/authSlice";
import { useTranslation } from "react-i18next";

const platforms = {
    "openai": {
      "name": "OpenAI",
      "rechargeUrl": "https://platform.openai.com/settings/organization/billing/overview"
    },
    "perplexity": {
      "name": "Perplexity",
      "rechargeUrl": "https://www.perplexity.ai/settings/api"
    }
};

export const useGenerationErrorHandling = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { accessToken, userInfo } = useSelector((state) => state.auth); // Adjust selector path

  return (error) => {
    if (error.status === 429) {
      const platform = error.data.detail.split("-")[0];
      const updatedUserInfo = {
        ...userInfo,
        [`${platform}_requires_funding`]: true
      };
      dispatch(setCredentials({ accessToken, userInfo: updatedUserInfo }));
      toast.error(
        <div>
          {t(`not-enough-fund-on-${platforms[platform].name}`, `Votre compte ${platforms[platform].name} n'a pas accès à ce modèle ou vous n'avez plus assez de fonds sur votre compte.`)}{" "}
          <span
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
            onClick={() => window.open("/profile?tab=integrations")}
          >
            {t("you-can-recharge-here", "Vous pouvez recharger votre compte ici.")}
          </span>
          !
        </div>
      );
    } else if (error.status === 401) {
      const platform = error.data.detail.split("-")[0];
      const updatedUserInfo = {
        ...userInfo,
        [`${platform}_api_key`]: null
      };
      dispatch(setCredentials({ accessToken, userInfo: updatedUserInfo }));
      toast.error(
        <div>
          {t(`wrong-api-key-on-${platforms[platform].name}`, `Votre clé API ${platforms[platform].name} semble incorrecte ou expirée.`)}{" "}
          <span
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
            onClick={() => window.open("/profile?tab=integrations", "_blank", "noopener,noreferrer,width=800,height=600")}
          >
            {t("you-can-create-a-new-one-and-add-it-here", "Vous pouvez en créer une nouvelle et l'ajouter ici.")}
          </span>
          !
        </div>
      );
    } else {
      toast.error(
        t(
          'something-went-wrong-with-generation',
          "Une erreur s'est produite lors de la génération"
        )
      );
    }
  };
};
